import { Project } from '../types/project';

import pic4 from '../assets/projects/inprogress.jpg';
import fallDashboard from '../assets/projects/fallDashboard/home.png';
import dataStruct from '../assets/projects/fallDashboard/dataStruct.png';
import util from '../assets/projects/fallDashboard/util.png';
import gender from '../assets/projects/fallDashboard/gender.png';
import context from '../assets/projects/travlr/context.png';
import ImageOptimaze from '../assets/projects/travlr/ImageOptimaze.png';
import imageServer from '../assets/projects/travlr/imageServer.png';
import mongodb from '../assets/projects/travlr/mongodb.png';
import schema from '../assets/projects/travlr/schema.png';
import structureBack from '../assets/projects/travlr/structureBack.png';
import structureFront from '../assets/projects/travlr/structureFront.png';
import addtripScreen from '../assets/projects/lovlytripKotlin/addtripScreen.png';
import deleteTrip from '../assets/projects/lovlytripKotlin/deleteTrip.png';
import splash from '../assets/projects/lovlytripKotlin/splash.png';
import tripDetails from '../assets/projects/lovlytripKotlin/tripDetails.png';
import tripList from '../assets/projects/lovlytripKotlin/tripList.png';
import travlr01 from '../assets/projects/travlr/home.gif';
import travlr02 from '../assets/projects/travlr/gallary.gif';
import travlr03 from '../assets/projects/travlr/list.gif';
import travlr04 from '../assets/projects/travlr/addTrip.gif';
import travlr05 from '../assets/projects/travlr/imagePick.gif';
import travlr06 from '../assets/projects/travlr/compass1.gif';

import factory1 from '../assets/projects/imageFactory/1.gif';
import factory2 from '../assets/projects/imageFactory/2.gif';
import factory3 from '../assets/projects/imageFactory/3.gif';
import factory4 from '../assets/projects/imageFactory/4.gif';
import factory5 from '../assets/projects/imageFactory/5.gif';
import factory6 from '../assets/projects/imageFactory/6.gif';
import factory7 from '../assets/projects/imageFactory/7.gif';
import factory8 from '../assets/projects/imageFactory/8.gif';
import factory9 from '../assets/projects/imageFactory/9.gif';

import parkingS01 from '../assets/projects/parkingSystem/parkingS01.gif';
import parkingS02 from '../assets/projects/parkingSystem/parkingS02.gif';
import parkingS03 from '../assets/projects/parkingSystem/parkingS03.gif';
import parkingS05 from '../assets/projects/parkingSystem/parkingS05.gif';
import parkingS06 from '../assets/projects/parkingSystem/parkingS06Android.gif';
import parkingS07 from '../assets/projects/parkingSystem/parkingS007Web.gif';

import userLogin from '../assets/projects/fall/userLogin.gif';
import datePicker from '../assets/projects/fall/datePicker.gif';
import allQuestions from '../assets/projects/fall/allQuestions.gif';
import submit from '../assets/projects/fall/submit.gif';

import { TECHNOLOGIES } from '../constants/technologies';

export const projects: Project[] = [
  {
    id: 'Travlr',
    title: 'Travel Journal Mobile App(Full Stack)',
    description: {
      overview:
        'A modern mobile application for documenting and preserving your travel memories. Capture your journeys with photos, locations, and detailed information about your trips.',
      features: [
        '📸 Photo capture and gallery integration',
        '📍 Location tracking for trips',
        '🗂️ Trip categorization',
        '⭐ Trip rating system',
        '📱 User-friendly interface',
        '🖼️ Image gallery with multiple photo support',
      ],
      challenges: [
        'Photo capture and gallery integration',
        'Rating system & Image management & Trip listing and filtering',
        'Typescript Implementation',
        'Implementation of NodeJS & Mongodb',
        'Rest API',
      ],
    },
    imageUrl: travlr01,
    images: [
      {
        url: travlr02,
        caption: 'Home Screen',
      },
      {
        url: travlr03,
        caption: 'Gallary',
      },
      {
        url: travlr04,
        caption: 'Add new Trip Screen',
      },
      {
        url: travlr05,
        caption: 'Gallary',
      },
      {
        url: travlr06,
        caption: 'Trip Details',
      },
      {
        url: context,
        caption: 'Context API',
      },
      {
        url: ImageOptimaze,
        caption: 'Image Optimaze',
      },
      {
        url: imageServer,
        caption: 'image Server',
      },
      {
        url: mongodb,
        caption: 'Mongodb Database',
      },
      {
        url: schema,
        caption: 'Backend Schema',
      },
      {
        url: structureFront,
        caption: 'Structure_Front',
      },
      {
        url: structureBack,
        caption: 'Structure Back',
      },
    ],
    category: 'react-native',
    metadata: {
      createdAt: '2024-08-15',
      lastUpdated: '2024-10-20',
      isOpenSource: true,
    },
    technologies: [
      TECHNOLOGIES.REACT_NATIVE,
      TECHNOLOGIES.EXPO,
      TECHNOLOGIES.CONTEXTAPI,
      TECHNOLOGIES.TYPESCRIPT,
      TECHNOLOGIES.TAILWIND,
      TECHNOLOGIES.ESLINT,
      TECHNOLOGIES.ENV,
      TECHNOLOGIES.NODEJS,
      TECHNOLOGIES.EXPRESS,
      TECHNOLOGIES.REST_API,
      TECHNOLOGIES.NODEJS,
      TECHNOLOGIES.MONGODB,
      TECHNOLOGIES.AXIOS,
      TECHNOLOGIES.JEST,
      TECHNOLOGIES.GITHUB,
      TECHNOLOGIES.GIT,
      TECHNOLOGIES.ESLINT,
      TECHNOLOGIES.PRETTIER,
    ],
    githubUrl: 'https://github.com/YahefuYusufu/Travlr',
    demoUrl: 'https://github.com/YahefuYusufu/Travlr',
  },
  {
    id: 'chart-analyst',
    title: 'CHART-ANALYST',
    description: {
      overview:
        'A comprehensive dashboard for analyzing and visualizing incident data with interactive features and dynamic updates.',
      features: [
        'Dashboard with multiple sections for data analysis',
        'Incident Date Analysis with trend visualization',
        'Location Insights with geographical data mapping',
        'Custom User Queries and data filtering',
        'Visual Data Representation using charts and graphs',
        'Animated Chart Lines with smooth transitions',
        'Dynamic updates for interactive data analysis',
      ],
      challenges: [
        'Implementing complex data visualization components',
        'Optimizing performance with large datasets',
        'Creating responsive and intuitive user interface',
        'Handling real-time data updates smoothly',
      ],
    },

    imageUrl: fallDashboard,
    images: [
      {
        url: fallDashboard,
        caption: 'Home Screen.',
      },
      {
        url: dataStruct,
        caption: 'Project Structure.',
      },
      {
        url: util,
        caption: 'One of the utils.',
      },
      {
        url: gender,
        caption: 'extract the gender from Personal Number.',
      },
    ],
    category: 'web',
    metadata: {
      createdAt: '2024-09-15',
      lastUpdated: '2024-10-20',
      isOpenSource: true,
    },
    technologies: [
      TECHNOLOGIES.REACT,
      TECHNOLOGIES.TAILWIND,
      TECHNOLOGIES.TYPESCRIPT,
      TECHNOLOGIES.AXIOS,
      TECHNOLOGIES.SASS,
      TECHNOLOGIES.VITE,
      TECHNOLOGIES.ESLINT,
      TECHNOLOGIES.ENV,
      TECHNOLOGIES.GIT,
      TECHNOLOGIES.GITHUB,
      TECHNOLOGIES.PRETTIER,
      TECHNOLOGIES.WEB3_JS,
      TECHNOLOGIES.NETLIFY,
    ],
    githubUrl: 'https://github.com/YahefuYusufu/fallDashboard',
    demoUrl: 'https://statistics-chart.netlify.app/',
  },
  {
    id: 'lovly-trip',
    title: 'LovlyTrip',
    description: {
      overview:
        'LovelyTrip is a modern Android travel companion app built with Jetpack Compose that helps wanderlusters document and plan their adventures! 🧳.',
      features: [
        '📝 Trip Documentation - Save detailed trip information including country, city, and dates',
        '📸 Photo Gallery - Upload and manage travel photos with Coil integration',
        '✍️ Trip Journaling - Write and save memorable trip summaries',
        '🗺️ Location Management - Organize trips by countries and cities',
        '📅 Calendar Integration - Plan trips with an intuitive calendar interface',
        '💫 Smooth Animations - Beautiful splash screen and transitions',
        '🎨 Material 3 Design - Modern and sleek user interface',
      ],
      challenges: [
        '📊 State Management: Complex UI state handling across multiple screens',
        '💾 Data Persistence: Efficient storage of trip data and images',
        '🖼️ Image Handling: Smooth transitions and responsive design',
      ],
    },
    imageUrl: tripList,
    images: [
      {
        url: splash,
        caption: 'Splash Screen - ',
      },
      {
        url: tripList,
        caption: 'Trip List Screen',
      },
      {
        url: addtripScreen,
        caption: 'Add Trip Screen',
      },
      {
        url: tripDetails,
        caption: 'Trip Details Screen',
      },
      {
        url: deleteTrip,
        caption: 'Delete Trip Screen',
      },
    ],
    category: 'android',
    metadata: {
      createdAt: '2024-02-15',
      lastUpdated: '2024-02-28',
      isOpenSource: true,
    },
    technologies: [
      TECHNOLOGIES.KOTLIN,
      TECHNOLOGIES.JETPACK_COMPOSE,
      TECHNOLOGIES.ROOM,
      TECHNOLOGIES.SPLASH_SCREEN,
      TECHNOLOGIES.DIALOG_CORE,
      TECHNOLOGIES.CALENDAR,
      TECHNOLOGIES.COIL,
      TECHNOLOGIES.GIT,
      TECHNOLOGIES.ESLINT,
      TECHNOLOGIES.ENV,
      TECHNOLOGIES.GITHUB,
    ],
    githubUrl: 'https://github.com/YahefuYusufu/LovelyTrip',
    demoUrl: 'https://github.com/YahefuYusufu/LovelyTrip',
  },
  {
    id: 'imageFactory',
    title: 'Image_Factory',
    description: {
      overview:
        'An amazing Android application that showcases beautiful images from the Unsplash API. ',
      features: [
        '🎨 Modern User Interface with Jetpack Compose',
        '✨ Polished Design with Material 3',
        '🚀 Engaging Splash Screen',
        '♾️ Smooth Content Loading with Paging 3',
        '🖼️ Efficient Image Loading with Coil',
        '🔄 Clean Architecture with Dagger Hilt',
        '🧭 Seamless Navigation',
        '🌐 Robust Networking with Retrofit',
        '💾 Local Data Management with Room',
      ],
      challenges: [
        '⚡ Jetpack Compose Challenges',
        '🎯 Material 3 Challenges',
        '🌟 Splash Screen Challenges',
        '📚 Paging 3 Challenges',
        '🎪 Coil Challenges',
        '⚙️ Dagger Hilt Challenges',
        '🧩 Navigation Challenges',
        '🔌 Retrofit Challenges',
        '🗄️ Room Challenges',
      ],
    },
    imageUrl: factory3,
    images: [
      {
        url: factory2,
        caption: 'Main Feed Screen',
      },
      {
        url: factory7,
        caption: 'Search Screen ',
      },
      {
        url: factory8,
        caption: 'Bookmarks Screen ',
      },
      {
        url: factory6,
        caption: 'Profile (WebView)',
      },
      {
        url: factory1,
        caption: 'Splash Screen  ',
      },
      {
        url: factory3,
        caption: 'Preview Image   ',
      },
      {
        url: factory4,
        caption: 'Zoom Image     ',
      },
      {
        url: factory5,
        caption: 'Download Image    ',
      },
      {
        url: factory9,
        caption: 'Dark Mode    ',
      },
    ],
    metadata: {
      createdAt: '2024-01-15',
      lastUpdated: '2024-03-20',
      isOpenSource: true,
    },
    category: 'android',
    technologies: [
      TECHNOLOGIES.KOTLIN,
      TECHNOLOGIES.JETPACK_COMPOSE,
      TECHNOLOGIES.ROOM,
      TECHNOLOGIES.ANDROID_JETPACK,
      TECHNOLOGIES.SPLASH_SCREEN,
      TECHNOLOGIES.COIL,
      TECHNOLOGIES.MATERIAL3,
      TECHNOLOGIES.PAGING3,
      TECHNOLOGIES.CLEANARCHITECTURE,
      TECHNOLOGIES.RETROFIT,
      TECHNOLOGIES.NAVIGATION,
    ],
    githubUrl: 'https://github.com/YahefuYusufu/Image_Factory',
    demoUrl: 'https://github.com/YahefuYusufu/Image_Factory',
  },
  {
    id: 'Fall App',
    title: 'FallApp',
    description: {
      overview:
        '📱FallApp is a specialized healthcare application designed to document and track fall incidents among elderly individuals. It serves as a critical bridge between caregivers and healthcare providers, enabling systematic documentation of fall events while contributing to a broader initiative for fall prevention and elderly care improvement.',
      features: [
        '🔐 Secure authentication system with simple passcode login for protecting sensitive patient information.',
        '👥 Patient management dashboard for easy selection and tracking of elderly individuals.',
        '📝 Step-by-step incident reporting process capturing time, location, causes, and responses to falls.',
        '📸 Photo documentation feature to capture incident locations and provide visual context.',
        '🔄 Real-time data synchronization with healthcare providers systems.',
      ],
      challenges: [
        '🔒 Ensuring HIPAA compliance and data security while maintaining seamless user experience.',
        '📱 Balancing comprehensive data collection with an elderly-friendly interface design.',
        '🌐 Managing offline functionality and data integrity during poor connectivity.',
        '⚡ Optimizing app performance for image processing and smooth transitions.',
        '🔗 Integration with existing healthcare systems and standardized data formats.',
      ],
    },
    imageUrl: userLogin,
    images: [
      {
        url: userLogin,
        caption: 'Login Screen - with personNummer',
      },
      {
        url: datePicker,
        caption: 'Date and Time Picker',
      },
      {
        url: allQuestions,
        caption: 'Multiple Selection.',
      },
      {
        url: submit,
        caption: 'Submit the Raport to Server.',
      },
    ],
    metadata: {
      createdAt: '2024-08-15',
      lastUpdated: '2024-10-01',
      isOpenSource: false,
    },
    category: 'react-native',
    technologies: [
      TECHNOLOGIES.REACT_NATIVE,
      TECHNOLOGIES.EXPO,
      TECHNOLOGIES.REDUX,
      TECHNOLOGIES.LOTTIE,
      TECHNOLOGIES.DATA_PICKER,
      TECHNOLOGIES.VECTOR_ICONS,
      TECHNOLOGIES.NODEJS,
      TECHNOLOGIES.EXPRESS,
      TECHNOLOGIES.REST_API,
      TECHNOLOGIES.NAVIGATION,
      TECHNOLOGIES.AXIOS,
      TECHNOLOGIES.ESLINT,
      TECHNOLOGIES.ENV,
      TECHNOLOGIES.GIT,
      TECHNOLOGIES.GITHUB,
    ],
    githubUrl: 'https://github.com/YahefuYusufu',
    demoUrl: 'https://github.com/YahefuYusufu',
  },
  {
    id: 'social-app',
    title: 'Inprogress',
    description: {
      overview:
        'A comprehensive dashboard for analyzing and visualizing incident data with interactive features and dynamic updates.',
      features: [
        'Dashboard with multiple sections for data analysis',
        'Incident Date Analysis with trend visualization',
        'Location Insights with geographical data mapping',
        'Custom User Queries and data filtering',
        'Visual Data Representation using charts and graphs',
        'Animated Chart Lines with smooth transitions',
        'Dynamic updates for interactive data analysis',
      ],
      challenges: [
        'Implementing complex data visualization components',
        'Optimizing performance with large datasets',
        'Creating responsive and intuitive user interface',
        'Handling real-time data updates smoothly',
      ],
    },
    imageUrl: pic4,
    images: [
      {
        url: pic4,
        caption: 'Home Screen - Current Weather',
      },
      {
        url: pic4,
        caption: 'Weekly Forecast View',
      },
      {
        url: pic4,
        caption: 'Weather Maps',
      },
    ],
    metadata: {
      createdAt: '2024-01-15',
      lastUpdated: '2024-02-20',
      isOpenSource: true,
    },
    category: 'ios',
    technologies: [
      TECHNOLOGIES.Inprogress,
      TECHNOLOGIES.Inprogress,
      TECHNOLOGIES.Inprogress,
      TECHNOLOGIES.Inprogress,
      TECHNOLOGIES.Inprogress,
      TECHNOLOGIES.Inprogress,
      TECHNOLOGIES.Inprogress,
      TECHNOLOGIES.Inprogress,
      TECHNOLOGIES.Inprogress,
      TECHNOLOGIES.Inprogress,
      TECHNOLOGIES.Inprogress,
      TECHNOLOGIES.Inprogress,
      TECHNOLOGIES.Inprogress,
    ],
    githubUrl: 'https://github.com/YahefuYusufu/fallDashboard',
    demoUrl: 'https://github.com/yourusername/portfolio',
  },
  {
    id: 'parking-system',
    title: 'ParkingSmart',
    description: {
      overview:
        'ParkSmart is a comprehensive parking management application built with Flutter for the client-side and SQLite3 for backend data management. The app provides a robust solution for managing parking spaces, vehicles, and parking sessions.',
      features: [
        'User registration and authentication ,Personal profile creation Secure login system Comprehensive CRUD functionality',
        'Vehicle Management with Comprehensive CRUD functionality',
        'Parking Space Management with Comprehensive CRUD functionality',
        'Parking Allocation with Intelligent parking space allocation Accurate time and fee calculation Real-time parking status tracking Sophisticated business logic for parking management ',
        'Advanced Search Functionality with Added an intelligent search feature for parking spaces Enables quick and efficient space discovery Provides real-time availability information',
        'Business Logic Excellence with Developed sophisticated parking allocation algorithms Precise time and fee calculation mechanisms Robust relationship management between different modules',
      ],
      challenges: [
        'Implementing CRUD functionality',
        'Search functionality',
        'Sophisticated business logic',
        'Full stack implementation.',
      ],
    },
    imageUrl: parkingS01,
    images: [
      {
        url: parkingS02,
        caption: 'IOS',
      },
      {
        url: parkingS03,
        caption: 'IOS',
      },
      {
        url: parkingS05,
        caption: 'IOS',
      },
      {
        url: parkingS06,
        caption: 'Android',
      },
      {
        url: parkingS07,
        caption: 'WEB',
      },
    ],
    metadata: {
      createdAt: '2025-03-04',
      lastUpdated: '2025-04-04',
      isOpenSource: false,
    },
    category: 'flutter',
    technologies: [
      TECHNOLOGIES.FLUTTER,
      TECHNOLOGIES.BLOC,
      TECHNOLOGIES.SQLITE,
      TECHNOLOGIES.REST_API,
      TECHNOLOGIES.VECTOR_ICONS,
      TECHNOLOGIES.DATA_PICKER,
      TECHNOLOGIES.GITHUB,
      TECHNOLOGIES.GIT,
      TECHNOLOGIES.ENV,
      TECHNOLOGIES.ESLINT,
    ],
    githubUrl: 'https://github.com/YahefuYusufu',
    demoUrl: 'https://projects-gallary.web.app/',
  },
];
